import React from 'react';

export const Container = ({children, id, className, mod, onClick=()=>{}}) => {
    return <div {...{id: id || null}} className={`container${mod ? mod: ''}${className ? ' '+className: ''}`} onClick={onClick}>{children}</div>
};


